import React from 'react';
import styles from './TextEffectsBauhaus.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { TestIds } from '../constants';

export type TextEffectsBauhausProps = TextEffectsSharedProps;

const TextEffectsBauhaus: React.FC<TextEffectsSharedProps> = props => {
  const { text } = props;

  return (
    <TextEffectsShared {...props}>
      <div
        className={styles.container}
        data-text={text}
        data-testid={TestIds.viewer.container}
      >
        <div className={styles.text} data-testid={TestIds.viewer.text}>
          {text}
        </div>
      </div>
    </TextEffectsShared>
  );
};

export default TextEffectsBauhaus;
